module.exports = __webpack_public_path__ + "img/electric_pending_zone.35ac4219.svg";